/**
 * Fiter-by/Sort-by menus (SHOP page).
 * 
 */

// Save the filter and sort values in formData.
const formData = new FormData();
let 
	prevFilter = '',
	prevSort = '';


// Populate and pre-select filter-by and sort-by menus based on query vars.
function setFilterSortMenus() {
	var urlParams;
	(window.onpopstate = function () {
	    var match,
	        pl     = /\+/g,  // Regex for replacing addition symbol with a space
	        search = /([^&=]+)=?([^&]*)/g,
	        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
	        query  = window.location.search.substring(1);
	  
	    urlParams = {};
	    while (match = search.exec(query))
	       urlParams[decode(match[1])] = decode(match[2]);
	})();

    if ( window.location.href.indexOf( 'py' ) != -1 ) {
        //gets the number from end of url
        var match = window.location.href.split('?')[1].match( /\d+$/ );
        var page_y = match[0];

        //sets the page offset 
        $( 'html, body' ).scrollTop( page_y );
    }

	// If filter set via query var, assign it.
	// If not, use default filter value (first radio button).
	var filterValue = urlParams['filter'];
	var filterValueDefault = $('.filter-by input').first().attr('value');
	if (!filterValue) {
		filterValue = filterValueDefault;
	}
	$('.filter-by input[value="'+filterValue+'"]').attr('checked', true);
	$('.filter-by .excol-side__panel-label').html(filterValue);

	// If sort set via query var, assign it.
	// If not, use default sort value (first radio button).
	var sortValue = urlParams['sort'];
	var sortValueDefault = $('.sort-by input').first().attr('value');
	if (!sortValue) {
		sortValue = sortValueDefault;
	}
	$('.sort-by input[value="'+sortValue+'"]').attr('checked', true);
	$('.sort-by .excol-side__panel-label').html(sortValue);

	formData.append('filter',filterValue);
	formData.append('sort',sortValue);

	prevFilter = filterValue;
	prevSort = sortValue;
}

// Initialize filter-by menu.
function initFilterForm() {
	// console.log('initFilterForm()');

	const sort_by_form = document.forms.filter;
	const filter_radio_btns = document.querySelectorAll('input[name="filter"]');

	function handleFilterSubmit(event) {
		event.preventDefault();
		// const formData = new FormData(event.target);
		var newFilter = $('input[name="filter"]:checked').val();
		formData.set('filter', newFilter);

		var params = new URLSearchParams(formData).toString();
		var new_filter_url = window.location.href.split('?')[0] + '?' + params;

		// Get page scroll position. Add to query string.
		var page_y = $(document).scrollTop();
		new_filter_url += '&py=' + page_y;

		if (newFilter != prevFilter) {
			// If a different filter has been selected, load filtered page.
			window.location.href = new_filter_url;
		} else {
			// Else, close menu panel.
	        var $myContent = $('.filter-by .excol-content');
	        var $myButton = $('.filter-by .btn-excol');
	        var $notMyButton = $('.btn-excol.open');
	        var $notMyContent = $('.excol-content.open');
	        // console.log($myContent);
	        if ($myContent.is(':hidden')) {
	            $myButton.toggleClass('open');
	            $myContent.toggleClass('open');
	            $myContent.slideDown(300);
	            $notMyButton.toggleClass('open');
	            $notMyContent.toggleClass('open');
	            $notMyContent.slideUp(300);
	        } else {
	            $myButton.toggleClass('open');
	            $myContent.toggleClass('open');
	            $myContent.slideUp(300,function() {
	                $myContent.hide();
	            });
	        }
	    }
	}

	// Trigger filter on closing menu panel.
	// sort_by_form.addEventListener('submit', handleFilterSubmit);

	// Trigger filter on clicking radio button.
	filter_radio_btns.forEach((el) => {
		el.addEventListener('change', handleFilterSubmit);
	});
}

// Initialize sort-by menu.
function initSortForm() {
	const sort_by_form = document.forms.sort;
	const sort_radio_btns = document.querySelectorAll('input[name="sort"]');

	function handleSortSubmit(event) {
		event.preventDefault();
		// const formData = new FormData(event.target);
		var newSort = $('input[name="sort"]:checked').val();
		formData.set('sort', newSort);

		var params = new URLSearchParams(formData).toString();
		var new_sort_url = window.location.href.split('?')[0] + '?' + params;

		// Get page scroll position. Add to query string.
		var page_y = $(document).scrollTop();
		new_sort_url += '&py=' + page_y;

		if (newSort != prevSort) {
			// If a different sort has been selected, load filtered page.
			window.location.href = new_sort_url;
		} else {
			// Else, close menu panel.
	        var $myContent = $('.sort-by .excol-content');
	        var $myButton = $('.sort-by .btn-excol');
	        var $notMyButton = $('.btn-excol.open');
	        var $notMyContent = $('.excol-content.open');
	        // console.log($myContent);
	        if ($myContent.is(':hidden')) {
	            $myButton.toggleClass('open');
	            $myContent.toggleClass('open');
	            $myContent.slideDown(300);
	            $notMyButton.toggleClass('open');
	            $notMyContent.toggleClass('open');
	            $notMyContent.slideUp(300);
	        } else {
	            $myButton.toggleClass('open');
	            $myContent.toggleClass('open');
	            $myContent.slideUp(300,function() {
	                $myContent.hide();
	            });
	        }
	    }
	}

	// Trigger sort on closing menu panel.
	// sort_by_form.addEventListener('submit', handleSortSubmit);

	// Trigger sort on clicking radio button.
	sort_radio_btns.forEach((el) => {
		el.addEventListener('change', handleSortSubmit);
	});

}

exports.init = function () {
    // Run init methods...
    setFilterSortMenus();
    initFilterForm();
    initSortForm();
};